import type { CanonicalDataType } from "@/shared/domain/topics";

export interface ColumnDefinition {
  /**
   * Logical key the value is stored under in `Log.data`. For a real column this
   * is the message-path name, so the same signal from several files shares one
   * `columnId`; for synthetic columns it's a sentinel ({@link ALL_COLUMNS_ID} /
   * {@link LOG_TIME_ID}). Not a per-file message-path id.
   */
  columnId: string;
  name: string;
  /**
   * Underlying per-file message-path ids (one per contributing file). Used to
   * add/remove the panel-data entries, which are keyed by message-path id.
   * Absent for synthetic columns.
   */
  messagePathIds?: string[];
  dataType?: CanonicalDataType;
  // When the column is categorical, the ordered list of category labels
  // (index → label). Used by Row to render e.g. "3 (Configured)".
  categories?: string[];
}

/**
 * Synthetic column ID used for filters that match against all fields.
 * This replaces the old global search term concept.
 */
export const ALL_COLUMNS_ID = "__all__";

/**
 * Display name for the synthetic "All columns" filter entry.
 */
export const ALL_COLUMNS_NAME = "All columns";

/**
 * Synthetic column ID for the built-in log timestamp.
 * Must match the schema key used by LogSearchEngine ("logtime").
 */
export const LOG_TIME_ID = "logtime";

/**
 * Display name for the built-in log timestamp filter entry.
 */
export const LOG_TIME_NAME = "Log time";
